import api from '../api'

export const bootstrap = ({ commit }) => {
    commit( 'LOAD' );
	api.bootstrap( content  => {
		commit( 'BOOTSTRAP', { content } )
        commit( 'UNLOAD' );
    })
}

export const update = ({ commit }) => {
    commit( 'LOAD' );
    api.update( content  => {
        commit( 'UPDATE', { content } )
        commit( 'UNLOAD' );
    })
}

export const getCategories = ({ commit }) => {
	api.getCategories( categories  => {
		commit( 'FETCH_CATEGORIES', { categories } )
    })
}

export const getProducts = ({ commit }) => {
	api.getProducts( products  => {
		commit( 'FETCH_PRODUCTS', { products } )
    })
}

export const onCategoryView = ({ commit }) => {
    commit( 'ON_CATEGORY_VIEW' )
}

export const onPostItem = ({ commit }) => {
    commit( 'ON_POST_VIEW' )
}

export const onNeutralPage = ({ commit }) => {
    commit( 'ON_NEUTRAL_VIEW' )
}

export const load = ({ commit }) => {
    commit( 'LOAD' )
}

export const unload = ({ commit }) => {
    commit( 'UNLOAD' )
}

export const installed = ({ commit }) => {
    commit( 'INSTALLED' )
}


// WEBPACK FOOTER //
// ./src/store/actions.js